import { render, staticRenderFns } from "./CustomPageSkeletonLoader.vue?vue&type=template&id=c2e8b42c&scoped=true"
import script from "./CustomPageSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./CustomPageSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./CustomPageSkeletonLoader.vue?vue&type=style&index=0&id=c2e8b42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e8b42c",
  null
  
)

export default component.exports